<template>
    <Head title="سبد خرید"/>
    <breadcrumb :links="[{title: 'سبد خرید'}]"/>
    <section class="py-4">
        <div class="container">

            <div v-if="cartBasedOnProduct.length" class="row g-4">
                <div class="col-lg-8">
                    <ul class="list-unstyled vstack gap-3">
                        <li v-for="product in cartBasedOnProduct" class="card card-body">
                            <a :href="product.url" class="hstack gap-3 align-items-start mb-3">
                                <img v-if="product.image" :src="product.image.url['90x90']" :alt="product.title"
                                     class="rounded img-fluid" width="90" height="90">
                                <div class="flex-fill">
                                    <h5 class="fw-bold">{{ product.title }}</h5>
                                    <h6 class="text-dark">{{ product.subtitle }}</h6>
                                </div>
                            </a>

                            <ul class="list-group border-0">
                                <li v-for="item in product.states"
                                    class="list-group-item hstack gap-3 bg-light border-0">
                                    <div class="flex-fill fw-bold">{{ item.state.title }}</div>
                                    <div class="fw-bold">{{ toFaNum(item.state.price) }} تومان</div>
                                    <div class="hstack gap-2">

                                        <a href="#"
                                           @click.prevent="addProductToCart({product: {...item.state, product}, showCanvas: false})">
                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5H9M5 1L5 9" stroke="currentColor" stroke-width="1.5"
                                                      stroke-linecap="round"/>
                                            </svg>
                                        </a>

                                        <div class="">{{ toFaNum(item.count) }}</div>

                                        <a href="#"
                                           @click.prevent="addProductToCart({product: {...item.state, product}, count: -1, showCanvas: false})">

                                            <svg v-if="item.count > 1" width="10" height="2" viewBox="0 0 10 2"
                                                 fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1H9" stroke="currentColor" stroke-width="1.5"
                                                      stroke-linecap="round"/>
                                            </svg>
                                            <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3 6.28259C2.58579 6.28259 2.25 6.61838 2.25 7.03259C2.25 7.44681 2.58579 7.78259 3 7.78259V6.28259ZM21 7.78259C21.4142 7.78259 21.75 7.44681 21.75 7.03259C21.75 6.61838 21.4142 6.28259 21 6.28259V7.78259ZM5 7.03259V6.28259H4.25V7.03259H5ZM19 7.03259H19.75V6.28259H19V7.03259ZM18.3418 16.8303L19.0624 17.0383L18.3418 16.8303ZM13.724 20.8553L13.8489 21.5949L13.724 20.8553ZM10.276 20.8553L10.401 20.1158L10.401 20.1158L10.276 20.8553ZM10.1183 20.8287L9.9933 21.5682H9.9933L10.1183 20.8287ZM5.65815 16.8303L4.93757 17.0383L5.65815 16.8303ZM13.8817 20.8287L13.7568 20.0892L13.8817 20.8287ZM7.84254 5.48939L8.52333 5.80406L7.84254 5.48939ZM8.81802 4.18112L8.31749 3.62258V3.62258L8.81802 4.18112ZM10.2779 3.30696L10.5389 4.01009L10.2779 3.30696ZM13.7221 3.30696L13.9831 2.60384V2.60384L13.7221 3.30696ZM16.1575 5.48939L16.8383 5.17471L16.1575 5.48939ZM3 7.78259H21V6.28259H3V7.78259ZM13.7568 20.0892L13.599 20.1158L13.8489 21.5949L14.0067 21.5682L13.7568 20.0892ZM10.401 20.1158L10.2432 20.0892L9.9933 21.5682L10.151 21.5949L10.401 20.1158ZM18.25 7.03259V12.1758H19.75V7.03259H18.25ZM5.75 12.1759V7.03259H4.25V12.1759H5.75ZM18.25 12.1758C18.25 13.6806 18.0383 15.1776 17.6212 16.6223L19.0624 17.0383C19.5185 15.4583 19.75 13.8212 19.75 12.1758H18.25ZM13.599 20.1158C12.5404 20.2947 11.4596 20.2947 10.401 20.1158L10.151 21.5949C11.3751 21.8017 12.6248 21.8017 13.8489 21.5949L13.599 20.1158ZM10.2432 20.0892C8.40523 19.7786 6.90157 18.4335 6.37873 16.6223L4.93757 17.0383C5.61878 19.3981 7.58166 21.1607 9.9933 21.5682L10.2432 20.0892ZM6.37873 16.6223C5.9617 15.1776 5.75 13.6806 5.75 12.1759H4.25C4.25 13.8212 4.48148 15.4583 4.93757 17.0383L6.37873 16.6223ZM14.0067 21.5682C16.4183 21.1607 18.3812 19.3981 19.0624 17.0383L17.6212 16.6223C17.0984 18.4335 15.5947 19.7786 13.7568 20.0892L14.0067 21.5682ZM8.25 7.03259C8.25 6.61367 8.34194 6.19649 8.52333 5.80406L7.16175 5.17471C6.89085 5.76079 6.75 6.39238 6.75 7.03259H8.25ZM8.52333 5.80406C8.70487 5.41133 8.97357 5.04881 9.31855 4.73966L8.31749 3.62258C7.82675 4.06235 7.43251 4.58893 7.16175 5.17471L8.52333 5.80406ZM9.31855 4.73966C9.66369 4.43037 10.0778 4.18126 10.5389 4.01009L10.0169 2.60384C9.38616 2.83798 8.80808 3.18295 8.31749 3.62258L9.31855 4.73966ZM10.5389 4.01009C11.0001 3.8389 11.4968 3.75 12 3.75V2.25C11.3213 2.25 10.6477 2.36972 10.0169 2.60384L10.5389 4.01009ZM12 3.75C12.5032 3.75 12.9999 3.8389 13.4611 4.01009L13.9831 2.60384C13.3523 2.36972 12.6787 2.25 12 2.25V3.75ZM13.4611 4.01009C13.9222 4.18126 14.3363 4.43037 14.6815 4.73966L15.6825 3.62258C15.1919 3.18295 14.6138 2.83798 13.9831 2.60384L13.4611 4.01009ZM14.6815 4.73966C15.0264 5.04881 15.2951 5.41133 15.4767 5.80407L16.8383 5.17471C16.5675 4.58893 16.1733 4.06235 15.6825 3.62258L14.6815 4.73966ZM15.4767 5.80406C15.6581 6.19649 15.75 6.61367 15.75 7.03259H17.25C17.25 6.39238 17.1092 5.7608 16.8383 5.17471L15.4767 5.80406ZM5 7.78259H19V6.28259H5V7.78259Z"
                                                    fill="currentColor"/>
                                                <path d="M10 12V16M14 12V16" stroke="currentColor"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round"/>
                                            </svg>
                                        </a>

                                    </div>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
                <div class="col-lg-4">
                    <div class="card bg-light card-body p-4">
                        <div v-if="user" class="vstack gap-4">
                            <div v-if="!validCoupon" class="">
                                <div class="hstack">
                                    <input v-model="couponCode" @keyup.enter="checkCoupon" type="text"
                                           :readonly="couponLoading"
                                           class="col form-control form-control-lg rounded-start rounded-0"
                                           placeholder="کد تخفیف">
                                    <button type="button" @click.prevent="checkCoupon" :disabled="couponLoading"
                                            class="ms-n3 btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 z-index-2">

                                        اعمال تخفیف

                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M3.85288 8.95043C4.50437 6.17301 6.67301 4.00437 9.45043 3.35288C11.4563 2.88237 13.5437 2.88237 15.5496 3.35288C18.327 4.00437 20.4956 6.17301 21.1471 8.95044C21.6176 10.9563 21.6176 13.0437 21.1471 15.0496C20.4956 17.827 18.327 19.9956 15.5496 20.6471C13.5437 21.1176 11.4563 21.1176 9.45044 20.6471C6.67301 19.9956 4.50437 17.827 3.85288 15.0496C3.38237 13.0437 3.38237 10.9563 3.85288 8.95043Z"
                                                stroke="white" stroke-width="1.5"/>
                                            <path d="M16 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="white"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>

                                    </button>

                                </div>
                                <div v-if="couponError" class="invalid-feedback d-block fw-bold mt-2">
                                    {{ couponError }}
                                </div>
                                <div v-if="couponValidationMsg" class="invalid-feedback d-block fw-bold mt-2">
                                    {{ couponValidationMsg }}
                                </div>
                            </div>

                            <div v-else
                                 class="bg-light-2 p-3 fw-bolder rounded border-primary border-2 border position-relative">
                                <button @click.prevent="removeCoupon" type="button"
                                        class="btn-close position-absolute end-0 top-0 mt-2 me-2"
                                        aria-label="Close"></button>
                                <div class="" v-html="couponError"></div>
                            </div>

                            <div class="hstack justify-content-between gap-2 fw-bolder">
                                <div>
                                    مبلغ کل سبد خرید
                                </div>
                                <div class="text-end fs-5">{{ toFaNum(cartTotalPrice) }} تومان</div>
                            </div>

                            <div v-if="form.errors.captcha_token" class="invalid-feedback d-block fw-bold">
                                {{ form.errors.captcha_token }}
                            </div>

                            <button @click.prevent="createBill"
                                    class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold w-100 fs-6 py-3">

                                ثبت سفارش

                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.85288 8.95043C4.50437 6.17301 6.67301 4.00437 9.45043 3.35288C11.4563 2.88237 13.5437 2.88237 15.5496 3.35288C18.327 4.00437 20.4956 6.17301 21.1471 8.95044C21.6176 10.9563 21.6176 13.0437 21.1471 15.0496C20.4956 17.827 18.327 19.9956 15.5496 20.6471C13.5437 21.1176 11.4563 21.1176 9.45044 20.6471C6.67301 19.9956 4.50437 17.827 3.85288 15.0496C3.38237 13.0437 3.38237 10.9563 3.85288 8.95043Z"
                                        stroke="white" stroke-width="1.5"/>
                                    <path d="M16 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="white" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                            </button>
                        </div>

                        <div v-else class="vstack gap-4">

                            <div class="hstack justify-content-between gap-2 fw-bolder">
                                <div>
                                    مبلغ کل سبد خرید
                                </div>
                                <div class="text-end fs-5">{{ toFaNum(cartTotalPrice) }} تومان</div>
                            </div>

                            <div class="alert bg-primary text-white mb-0">
                                جهت ثبت سفارش باید به حساب کاربری خود وارد شوید
                            </div>

                            <a href="/login?redirect=%2Fcart"
                               class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold w-100 fs-6 py-3">

                                ورود جهت ثبت سفارش

                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.85288 8.95043C4.50437 6.17301 6.67301 4.00437 9.45043 3.35288C11.4563 2.88237 13.5437 2.88237 15.5496 3.35288C18.327 4.00437 20.4956 6.17301 21.1471 8.95044C21.6176 10.9563 21.6176 13.0437 21.1471 15.0496C20.4956 17.827 18.327 19.9956 15.5496 20.6471C13.5437 21.1176 11.4563 21.1176 9.45044 20.6471C6.67301 19.9956 4.50437 17.827 3.85288 15.0496C3.38237 13.0437 3.38237 10.9563 3.85288 8.95043Z"
                                        stroke="white" stroke-width="1.5"/>
                                    <path d="M16 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="white" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                            </a>
                        </div>

                    </div>
                </div>
            </div>

            <div v-else-if="!cartLoading" class="text-center">
                <h3 class="fw-bold mb-4">سبد خرید شما خالی است!</h3>
                <a href="/shop"
                   class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 px-5">
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.69922 7L9.49802 7.47905C9.1732 8.25243 9.09156 9.10637 9.26395 9.92729C9.52699 11.1799 10.5242 12.1473 11.7842 12.3723L11.8951 12.3921C12.2947 12.4635 12.7038 12.4635 13.1033 12.3921L13.2143 12.3723C14.4743 12.1473 15.4714 11.1799 15.7345 9.92729C15.9069 9.10637 15.8252 8.25243 15.5004 7.47905L15.2992 7"
                            stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
                        <path
                            d="M20.7224 15.1432C20.1522 17.6506 18.2032 19.6206 15.7039 20.2254C13.6035 20.7336 11.3998 20.7336 9.29936 20.2254C6.80008 19.6206 4.85107 17.6506 4.2809 15.1432C3.77146 12.9029 3.89536 10.565 4.63873 8.39108L4.74917 8.06811C5.56712 5.6761 7.61047 3.91037 10.0958 3.44791L10.7764 3.32126C11.9168 3.10906 13.0865 3.10906 14.2269 3.32126L14.9075 3.4479C17.3928 3.91037 19.4362 5.6761 20.2541 8.06813L20.3646 8.39109C21.1079 10.565 21.2318 12.9029 20.7224 15.1432Z"
                            stroke="white" stroke-width="1.5"></path>
                    </svg>
                    ورود به فروشگاه </a>
            </div>

        </div>
    </section>

</template>

<script>
import {computed, ref} from "vue";
import Breadcrumb from "../Components/Breadcrumb";
import {useStore, mapState, mapGetters, mapActions} from "vuex";
import {Head, useForm} from '@inertiajs/inertia-vue3';
import {useReCaptcha} from 'vue-recaptcha-v3';
import {gaState} from "../helpers";

export default {
    components: {
        Breadcrumb,
        Head,
    },
    setup() {
        const store = useStore()

        const items = computed(() => store.state.cart.items)

        const getCartItems = () => store.dispatch('cart/getCartItems')

        const addToast = () => store.commit('toasts/addToast')

        const form = useForm({
            code: null,
            captcha_token: null,
        })

        const {executeRecaptcha, recaptchaLoaded} = useReCaptcha()

        const createBill = async () => {
            gtag("event", "begin_checkout", {
                currency: "USD",
                value: 0,
                coupon: form.code,
                items: items.value.map(item => gaState(item.state, item.count)),
            })
            // await recaptchaLoaded()
            // form.captcha_token = await executeRecaptcha('createBill')
            form.captcha_token = 'x'
            form.post('/checkout', {
                onSuccess: () => {
                    getCartItems()
                },
                onError: () => {
                    if (form.errors.message) {
                        getCartItems()
                        addToast({
                            type: 'error',
                            content: form.errors.message,
                        })
                    }
                }
            })
        }

        const couponError = ref(null)
        const couponLoading = ref(false)
        const couponCode = ref(null)
        const validCoupon = ref(false)
        const couponValidationMsg = ref(null)

        const checkCoupon = async () => {
            couponError.value = null
            couponValidationMsg.value = null
            if (!couponCode.value) {
                return
            }
            couponLoading.value = true
            // await recaptchaLoaded()
            // const captcha_token = await executeRecaptcha('checkCoupon')
            const captcha_token = 'x'
            axios.post('/api/v1/index/check-coupon', {
                captcha_token,
                code: couponCode.value,
                states: items.value.map(item => ({
                    count: item.count,
                    id: item.state.id,
                })),
            }).then(response => {
                const {data} = response
                if (data.success) {
                    validCoupon.value = true
                    form.code = couponCode.value
                }
                couponError.value = data.message
            }).catch((e) => {
                if (e.response.status === 422) {
                    couponValidationMsg.value = e.response.data.message
                }
            }).then(() => {
                couponLoading.value = false
            })
        }

        return {
            form,
            createBill,
            items,
            couponError,
            couponLoading,
            couponCode,
            validCoupon,
            checkCoupon,
            couponValidationMsg
        }
    },
    computed: {
        ...mapGetters('cart', [
            'cartBasedOnProduct',
            'cartTotalPrice'
        ]),
        ...mapState('cart', [
            'cartLoading',
        ]),
        ...mapState('auth', [
            'user',
        ])
    },
    methods: {
        ...mapActions('cart', [
            'addProductToCart',
        ]),
        removeCoupon() {
            this.couponError = null
            this.form.code = null
            this.couponCode = null
            this.validCoupon = false
        },
    },

}
</script>

<style scoped>

</style>
